export default __webpack_public_path__ + "static/media/grass.6f08511d.png";